import LoginRedirect from '@eui-page/auth0-login-redirect';
import LogoutRedirect from '@eui-page/auth0-logout-redirect';
import RouteNames from './route-names';
import MainLayout from '../components/layouts/main-layout';
import { SAIPageSpinner } from 'ecx.saigon.ui.common';
import store from '../store';
import { LOGIN_THEME, ROUTE_BASE } from '@/utils/constants';
import { getEnv } from 'ecx.saigon.ui.common';
import resolveLocalRoute from '@/utils/resolve-local-route';

export default [
  // Un Authenticated Routes
  {
    path: '/login',
    name: RouteNames.login,
    component: LoginRedirect,
    meta: { skipAuthentication: true },
    async beforeEnter(to, from, next) {
      const env = await getEnv();
      const windowPathname = window.location.pathname.replace(ROUTE_BASE, '');
      const windowSearch = window.location.search;
      to.query.fromPath = `${windowPathname}${windowSearch}`;
      to.meta.baseUrl = resolveLocalRoute(ROUTE_BASE);
      next();
    },
    props: (route) => {
      return {
        redirectLoginOptions: {
          appState: { fromPath: route.query.fromPath },
          redirect_uri: route.query.redirectUri || route.meta.baseUrl,
          fragment: `&theme=${LOGIN_THEME}&baseUrl=${route.meta.baseUrl}`
        }
      };
    }
  },
  {
    path: '/logout',
    name: RouteNames.logout,
    meta: { skipAuthentication: true },
    props: { returnTo: `${window.location.origin}/quotes/login` },
    component: LogoutRedirect,
    async beforeEnter(to, from, next) {
      store.commit('user/clearUserData');

      if ('leaseId' in from.query) {
        const env = await getEnv();
        window.location = `${env.VUE_APP_CORE_ROUTE}/logout`;
        return false;
      } else next();
    }
  },
  {
    path: '/:quoteId?',
    alias: '',
    props: true,
    redirect: { name: RouteNames.redirection },
    component: () => import('../widgets/quote'),
    children: [
      {
        path: 'calculator',
        name: RouteNames.calculator,
        meta: { layout: MainLayout },
        component: () => import('../widgets/calculator')
      },
      {
        path: 'budget',
        name: RouteNames.budget,
        meta: { layout: MainLayout },
        component: () => import('../widgets/budget')
      },
      {
        path: 'summary',
        name: RouteNames.summary,
        meta: { layout: MainLayout },
        component: () => import('../widgets/summary')
      },
      {
        path: 'hr-approval',
        name: RouteNames.hrApproval,
        meta: { layout: MainLayout },
        component: () => import('../widgets/hr-approval')
      },
      {
        path: 'hr-approval-sent',
        name: RouteNames.hrApprovalSent,
        meta: { layout: MainLayout },
        component: () => import('../widgets/hr-approval-sent')
      },
      {
        path: 'car-search',
        name: RouteNames.carSearch,
        meta: { layout: MainLayout },
        component: () => import('../widgets/car-search')
      },
      {
        path: 'quote-upload',
        name: RouteNames.quoteUpload,
        meta: { layout: MainLayout },
        component: () => import('../widgets/quote-upload')
      },
      {
        path: 'car-search-variant',
        name: RouteNames.carSearchVariant,
        meta: { layout: MainLayout },
        component: () => import('../widgets/car-search-variant')
      },
      {
        path: 'car-colour-and-extras',
        name: RouteNames.carColourAndExtras,
        meta: { layout: MainLayout },
        component: () => import('../widgets/car-colour-and-extras')
      },
      {
        path: 'dealer-price',
        name: RouteNames.dealerPrice,
        meta: { layout: MainLayout },
        component: () => import('../widgets/dealer-price')
      },
      {
        path: 'vehicle-ordered',
        name: RouteNames.vehicleOrdered,
        meta: { layout: MainLayout },
        component: () => import('../widgets/vehicle-ordered')
      },
      {
        path: 'redirection',
        name: RouteNames.redirection,
        meta: { layout: MainLayout },
        component: SAIPageSpinner
      },
      {
        path: 'not-found',
        name: RouteNames.quoteNotFound,
        meta: { layout: MainLayout },
        component: () => import('../components/molecule/quote-not-found')
      }
    ]
  }
];
